import { render, staticRenderFns } from "./UsuarioGrupoGet.vue?vue&type=template&id=6cbb08a0&scoped=true"
import script from "./UsuarioGrupoGet.vue?vue&type=script&lang=js"
export * from "./UsuarioGrupoGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb08a0",
  null
  
)

export default component.exports